import { useAtom } from "jotai";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { Pageable } from "../../../services/pageable";
import { useDefaultQueryOptions } from "../../../store/client-query";
import { ALL_MERCHANTS } from "../../../store/merchants/resources";
import { UsersDTO } from "../../../store/users/models/dto";
import { UsersService } from "../../../store/users/service";
import { merchantPagination } from "./atoms";

type PageableState = Pageable.T<keyof UsersDTO.Responses.GetSingle.T> & {
  options?:
    | {
        excludeSubMerchants?: boolean | undefined;
      }
    | undefined;
};

export const useAllMerchants = (search?: string) => {
  const [pagination, setPagination] = useAtom(merchantPagination);

  useEffect(() => {
    setPagination({
      sorting: {
        direction: "desc",
        field: "createdDate",
      },
      options: {
        excludeSubMerchants: true,
      },
    });
  }, [search]);

  return useQuery<
    UsersDTO.Responses.GetAllMerchants.T,
    Error,
    UsersDTO.Responses.GetAllMerchants.T,
    [string, PageableState, string | undefined]
  >(
    [ALL_MERCHANTS, pagination, search],
    ({ queryKey }) =>
      UsersService.getAllMerchants({
        ...queryKey[1],
        filters: queryKey[2]
          ? [{ field: "companyDetails", value: queryKey[2] }]
          : [],
        options: {
          excludeSubMerchants: true,
        },
      }),
    useDefaultQueryOptions()
  );
};
